import { IGetAllItemPesquisaClienteUseCase } from "../../../presentation/useCases/read/get_all_item_pesquisa_cliente_use_case";
import { ItemPesquisaClienteLista } from "../../models/item_pesquisa_cliente_lista";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetAllItemPesquisaClienteUseCase
 */

export class GetAllItemPesquisaClienteUseCase implements IGetAllItemPesquisaClienteUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async getAllItemPesquisaCliente(
    idPesquisaSatisfacaoCliente: number | undefined,
  ): Promise<ItemPesquisaClienteLista[]> {
    if (idPesquisaSatisfacaoCliente === undefined) {
      throw new Error("Falha ao obter ID Pesquisa Satisfação do Cliente.");
    }
    return this.repository.getAllItemPesquisaCliente(idPesquisaSatisfacaoCliente);
  }
}
